<template>
    <div>
        <div class="card-body text-center">
            <h4><i class="fas fa-check-circle text-success"></i>&nbsp;Successfully confirmed.</h4>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                Admin has confirmed the contract so the contract is the valid one.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Complete"
    }
</script>

<style scoped>

</style>
